// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Absolute Center Spinner */
.vv-loading-background {
  position: fixed;
  z-index: 1200;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.vv-loading-background:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(255, 255, 255, 0.542); */
  background-color: rgba(0, 0, 0, 0.118);
  /* background-color: rgba(46, 93, 196, 0.761); */
}

.override-menu {
  right: 0;
  left: inherit;
}

#vv-loader {
  border-top: 18px solid #22AADE;
  border-right: 18px solid rgba(255, 255, 255, 0.501);
  border-bottom: 18px solid #D02433;
  border-left: 18px solid rgba(255, 255, 255, 0.501);
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  width: 130px;
  height: 130px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0
  }

  to {
    bottom: 0;
    opacity: 1
  }
}

#myDiv {
  display: none;
  text-align: center;
}

.btn-export {
  background-color: green;
}

.input-text {
  border-radius: 3px;
  width: 40px;
  padding: 5px 3px 5px 3px;
  outline: none;
  text-align: center;
}


.label__checkbox {
  display: none;
}

.label__check {
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.3);
  background-color: white;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border .4s ease;
}


.icon {
  top: 0px;
  left: 0px;
  opacity: .2;
  font-size: 10px;
  color: transparent;
  transform: scale(.8);
  transition: opacity .4s .1s ease;
  -webkit-text-stroke: 3px rgba(0, 0, 0, 0.5);
}

.label__check:hover {
  border: 4px solid rgba(0, 0, 0, 0.2);
}

.label__checkbox:checked+.label__text .label__check {
  animation: check .5s cubic-bezier(1, .03, 0.7, 0.2) forwards;
}

.label__checkbox:checked+.label__text .label__check .icon {
  opacity: 1;
  transform: scale(0);
  color: white;
  -webkit-text-stroke: 0;
  /* transform: translate(-50%, -50%); */
  animation: icon .3s cubic-bezier(1, .01, .5, 1.6) .15s forwards;
}

@keyframes icon {
  from {
      opacity: 0;
      color: white;
      transform: scale(.3);
  }

  to {
      opacity: 1;
      color: white;
      transform: scale(1);
  }
}


@keyframes check {
  0% {
      width: 15px;
      height: 15px;
  }

  10% {
      width: 15px;
      height: 15px;
      opacity: 0.1;
      background-color: rgba(0, 0, 0, 0.2);
  }

  15% {
      width: 15px;
      height: 15px;
      opacity: .4;
      background-color: rgba(0, 0, 0, 0.1);
      border-width: 0;
  }

  50% {
      width: 22px;
      height: 22px;
      opacity: .6;
      background: #0066B2;
      border: 0;
  }

  100% {
      width: 22px;
      height: 22px;
      opacity: 1;
      background: #0066B2;
      border: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,UAAU;EACV,cAAc;EACd,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mDAAmD;EACnD,iCAAiC;EACjC,kDAAkD;EAClD,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EAEb,oCAAoC;AACtC;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qCAAqC;EACrC,8BAA8B;EAC9B,6BAA6B;EAC7B;AACF;;AAcA;EACE;IACE,cAAc;IACd;EACF;;EAEA;IACE,SAAS;IACT;EACF;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;;AAGA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,+DAA+D;AACjE;;AAEA;EACE;MACI,UAAU;MACV,YAAY;MACZ,oBAAoB;EACxB;;EAEA;MACI,UAAU;MACV,YAAY;MACZ,mBAAmB;EACvB;AACF;;;AAGA;EACE;MACI,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,oCAAoC;EACxC;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,WAAW;MACX,oCAAoC;MACpC,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,SAAS;EACb;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,SAAS;EACb;AACF","sourcesContent":["/* Absolute Center Spinner */\n.vv-loading-background {\n  position: fixed;\n  z-index: 1200;\n  height: 2em;\n  width: 2em;\n  overflow: show;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n/* Transparent Overlay */\n.vv-loading-background:before {\n  content: '';\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* background-color: rgba(255, 255, 255, 0.542); */\n  background-color: rgba(0, 0, 0, 0.118);\n  /* background-color: rgba(46, 93, 196, 0.761); */\n}\n\n.override-menu {\n  right: 0;\n  left: inherit;\n}\n\n#vv-loader {\n  border-top: 18px solid #22AADE;\n  border-right: 18px solid rgba(255, 255, 255, 0.501);\n  border-bottom: 18px solid #D02433;\n  border-left: 18px solid rgba(255, 255, 255, 0.501);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin: -75px 0 0 -75px;\n  border-radius: 50%;\n  width: 130px;\n  height: 130px;\n  -webkit-animation: spin 1.5s linear infinite;\n  animation: spin 1.5s linear infinite;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Add animation to \"page content\" */\n.animate-bottom {\n  position: relative;\n  -webkit-animation-name: animatebottom;\n  -webkit-animation-duration: 1s;\n  animation-name: animatebottom;\n  animation-duration: 1s\n}\n\n@-webkit-keyframes animatebottom {\n  from {\n    bottom: -100px;\n    opacity: 0\n  }\n\n  to {\n    bottom: 0px;\n    opacity: 1\n  }\n}\n\n@keyframes animatebottom {\n  from {\n    bottom: -100px;\n    opacity: 0\n  }\n\n  to {\n    bottom: 0;\n    opacity: 1\n  }\n}\n\n#myDiv {\n  display: none;\n  text-align: center;\n}\n\n.btn-export {\n  background-color: green;\n}\n\n.input-text {\n  border-radius: 3px;\n  width: 40px;\n  padding: 5px 3px 5px 3px;\n  outline: none;\n  text-align: center;\n}\n\n\n.label__checkbox {\n  display: none;\n}\n\n.label__check {\n  border-radius: 50%;\n  border: 4px solid rgba(0, 0, 0, 0.3);\n  background-color: white;\n  vertical-align: middle;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border .4s ease;\n}\n\n\n.icon {\n  top: 0px;\n  left: 0px;\n  opacity: .2;\n  font-size: 10px;\n  color: transparent;\n  transform: scale(.8);\n  transition: opacity .4s .1s ease;\n  -webkit-text-stroke: 3px rgba(0, 0, 0, 0.5);\n}\n\n.label__check:hover {\n  border: 4px solid rgba(0, 0, 0, 0.2);\n}\n\n.label__checkbox:checked+.label__text .label__check {\n  animation: check .5s cubic-bezier(1, .03, 0.7, 0.2) forwards;\n}\n\n.label__checkbox:checked+.label__text .label__check .icon {\n  opacity: 1;\n  transform: scale(0);\n  color: white;\n  -webkit-text-stroke: 0;\n  /* transform: translate(-50%, -50%); */\n  animation: icon .3s cubic-bezier(1, .01, .5, 1.6) .15s forwards;\n}\n\n@keyframes icon {\n  from {\n      opacity: 0;\n      color: white;\n      transform: scale(.3);\n  }\n\n  to {\n      opacity: 1;\n      color: white;\n      transform: scale(1);\n  }\n}\n\n\n@keyframes check {\n  0% {\n      width: 15px;\n      height: 15px;\n  }\n\n  10% {\n      width: 15px;\n      height: 15px;\n      opacity: 0.1;\n      background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  15% {\n      width: 15px;\n      height: 15px;\n      opacity: .4;\n      background-color: rgba(0, 0, 0, 0.1);\n      border-width: 0;\n  }\n\n  50% {\n      width: 22px;\n      height: 22px;\n      opacity: .6;\n      background: #0066B2;\n      border: 0;\n  }\n\n  100% {\n      width: 22px;\n      height: 22px;\n      opacity: 1;\n      background: #0066B2;\n      border: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
